import type React from 'react';

export interface DashboardIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const DashboardIcon: React.FC<DashboardIconProps> = ({
	width = 21,
	height = 21,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Dashboard Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 21 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M16.6709 11.0002V16.6663H12.2549V11.0002H16.6709ZM8.75488 13.5002V16.6663H4.33789V13.5002H8.75488ZM8.75488 4.33325V10.0002H4.33789V4.33325H8.75488ZM16.6709 4.33325V7.50024H12.2549V4.33325H16.6709Z"
			stroke="currentColor"
		/>
	</svg>
);

export default DashboardIcon;
